<style scoped lang="scss" type="text/scss">
    .group-photo {
        height: 20rem;
    }
</style>

<template>
    <div class="">
        <placeholder v-if="data === null">
            未上传合照
        </placeholder>
        <img class="group-photo" :src="src" alt="" v-else>
    </div>
</template>

<script>
    import Placeholder from '@/components/placeholder/index';
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            data: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            Placeholder
        },
        computed: {
            src () {
                return _.get(this.data, 'url', this.imagePlaceholder);
            },
            imagePlaceholder () {
                return this.$store.state.imagePlaceholder;
            }
        },
        data () {
            return {};
        }
    };
</script>
